import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FrequencyEnum } from 'src/app/shared/enum/prescription.enum';
import { MedicineStruct } from 'src/app/shared/services/structs/pharmacy/medicine.struct';
import { AllergyModel } from 'src/app/shared/services/models/medical-record/allergy.model';
import { AuxStandardPrescriptionStruct } from 'src/app/shared/services/structs/pharmacy/aux-standard-prescription.struct';
import { MedicConfigSectorStruct } from '../../services/structs/medic/medic-config-sector.struct';
import { LookupsBooleanChoiceRequest } from '../../services/requests/pharmacy/lookups-boolean-choice.request';
import { PharmacyLookupService } from '../../services/API/pharmacy/pharmacy-lookup.service';
import { RelationMedicinePresentationTypeAndDoseToAdministered } from '../../services/models/pharmacy/relation-medicine-presentation-type-and-dose-to-administered.model';
import { AlertService, AlertType } from '../../services/alert.service';
import { PharmacyConfig } from '../../services/models/pharmacy/pharmacy-config.model';

@Component({
    selector: 'app-prescription-modal',
    templateUrl: './prescription-modal.component.html',
    styleUrls: ['./prescription-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescriptionModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public alertService: AlertService,
    public matDialogRef: MatDialogRef<PrescriptionModalComponent>,
    private lookupService: PharmacyLookupService,
  ) { }

  public prescription: AuxStandardPrescriptionStruct = new AuxStandardPrescriptionStruct();
  public frequencyNow: any;
  public selectedMedicineList: MedicineStruct[] = [];
  public medicineList: MedicineStruct[] = [];
  public usageList: any[] = [];
  public administrationTypeList: any[] = [];
  public frequencyList: any[] = [];
  public presentationList: any[] = [];
  public treatmentList: any[] = [];
  public dilutionList: any[] = [];
  public dilutionUnitList: any[] = [];
  public measurementUnitList: any[] = [];
  public listAllergy: AllergyModel[] = [];
  public listSubFrequency: any[];
  public listRelationMedicinePresentationTypeAndDoseToAdministered: RelationMedicinePresentationTypeAndDoseToAdministered[] = [];

  public frequencyEnum: FrequencyEnum = FrequencyEnum.now;

  public idFrequency: number

  public isLoading: boolean;
  public readOnly: boolean;
  public blockAllergicPrescription: boolean = false;
  public bypassPrescription: boolean = false;
  public isMedicatedSolution: boolean = false;
  public pharmacyConfig?: PharmacyConfig;
  medicConfig: MedicConfigSectorStruct;
  ngOnInit(): void {
    this.isLoading = false;
    if (this.data.prescription != null)
      this.prescription = this.data.prescription;
    else {
      this.prescription.prescriptionMedicineStruct = null;
      this.prescription.prescriptionSolutionStruct = null;
    }

    
    this.blockAllergicPrescription = this.data?.blockAllergicPrescription;
    this.readOnly = this.data.readOnly;
    this.medicineList = this.data.listMedicine.listMedicineStruct;
    this.listAllergy = this.data.listAllergy;
    console.log(this.data);
    this.pharmacyConfig = this.data?.pharmacyConfig;
    this.selectedMedicineList = this.data.listMedicine.listMedicineStruct;
    this.medicConfig = this.data.medicConfig;
    this.populateLookup();
    this.populatePharmacyLookups();

    if (this.data.isMedicatedSolution != null)
      this.isMedicatedSolution = this.data.isMedicatedSolution;

  }

  populateLookup() {
    this.usageList = this.data?.listUsage;
    this.administrationTypeList = this.data?.listAdministrationType;
    this.frequencyList = this.data?.listFrequency;
    this.presentationList = this.data?.listPresentation;
    if (this.readOnly)
      this.treatmentList = this.data?.listAllTreatmentPeriod;
    else
      this.treatmentList = this.data?.listTreatmentPeriod;
    this.dilutionList = this.data?.listDilution;
    this.measurementUnitList = this.data?.listMeasurementUnit;
    this.dilutionUnitList = this.data?.listDilutionUnit;
    this.listSubFrequency = this.data?.listSubFrequency;
    if (this.frequencyList) {
      this.organizeList()
    }
  }

  close() {
    this.matDialogRef.close();
  }

  submit(request: any) {
    this.prescription = new AuxStandardPrescriptionStruct()
    if (this.isMedicatedSolution) {
      this.prescription.prescriptionMedicineStruct = null;
      this.prescription.prescriptionSolutionStruct = request.prescriptionSolution;
    }
    else {
      this.prescription.prescriptionMedicineStruct = request.prescriptionMedicine;
      this.prescription.prescriptionSolutionStruct = null;
    }
    this.matDialogRef.close({ prescription: this.prescription, bypassPrescription: request.bypassPrescription });
  }

  organizeList() {
    this.frequencyNow = this.frequencyList.find(x => x.idFrequency == this.frequencyEnum.valueOf());
    this.frequencyList.splice(this.frequencyList.findIndex(x => x.idFrequency == this.frequencyEnum.valueOf()), 1);
    this.frequencyList.unshift(this.frequencyNow);
  }

  changeToMedicatedSolution(event: any) {
    this.isMedicatedSolution = !this.isMedicatedSolution;
  }

  populatePharmacyLookups() {
    let request: LookupsBooleanChoiceRequest = new LookupsBooleanChoiceRequest();
    request.isToGetRelationMedicinePresentationTypeAndDoseToAdministered = true;

    this.lookupService.searchLookupsUsingBooleanRequestFilter(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this.listRelationMedicinePresentationTypeAndDoseToAdministered = [];

        if (response.listRelationMedicinePresentationTypeAndDoseToAdministered && response.listRelationMedicinePresentationTypeAndDoseToAdministered.length > 0)
          this.listRelationMedicinePresentationTypeAndDoseToAdministered = [...response.listRelationMedicinePresentationTypeAndDoseToAdministered];
      },
      error: (error) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

}